module.exports = __webpack_public_path__ + "img/icon_premium.e6e3491d.svg";